import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import Store from "./store";
import * as ReactRouter from "react-router-dom";

import AppContainer from "./AppContainer";
const { Router, Route, Redirect, Switch, BrowserRouter } = ReactRouter;
import createHistory from "history/createBrowserHistory";

const history = createHistory();
const store = Store(history)();

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <AppContainer />
    </Router>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./client/index.tsx